<template>
  <portlet
    :icon="'fad fa-user'"
    :title="'Kandidaat plaatsen'"
    :footer="true"
  >

    <template slot="portletBody">
      <div class="row">
        <div class="form-group col-lg-6">
          <label for="candidatePlacement-customer">Bedrijf</label>
          <input readonly
                 id="candidatePlacement-customer"
                 type="text"
                 class="form-control"
                 v-model="customerName"
          />
        </div>
        <div class="form-group col-lg-6">
          <label for="candidatePlacement-vacancy">Vacature</label>
          <v-select
            :options="getVacanciesFromCustomer(id)"
            :selectOnTab="true"
            label="name"
            v-model="candidatePlacement.vacancyId"
            :reduce="getVacanciesFromCustomer => getVacanciesFromCustomer.id"
          >
            <div slot="no-options">Er zijn geen vacatures aangemaakt.</div>
          </v-select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-4">
          <label for="candidatePlacement-candidate">Kandidaat</label>
          <v-select
            :options="getAvailableCandidatesPerCustomer(id)"
            v-if="renderedComponent"
            :selectOnTab="true"
            :get-option-label="getCandidateLabel"
            v-model="candidatePlacement.candidateId"
            v-validate="'required'"
            name="candidate"
            :class="{ 'is-invalid': errors.has('candidate')}"
            :reduce="getAvailableCandidatesPerCustomer => getAvailableCandidatesPerCustomer.id"
          >
            <div slot="no-options">Alle kandidaten zijn geplaatst.</div>
          </v-select>
          <span v-if="errors.first('candidate')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-lg-3">
          <label for="candidatePlacement-startDate">Begin datum</label>
          <datepicker
            :language="nl"
            id="startDate"
            v-model="candidatePlacement.startDate"
            :fullMonthName="true"
            format="dd-MM-yyyy"
            input-class="form-control"
            :calendar-button="true"
            :calendar-button-icon="'far fa-calendar-alt'"
            :clear-button="true"
            :clear-button-icon="'far fa-times'"
            :class="{ 'is-invalid': errors.has('availableDate') }"
          ></datepicker>
          <input v-model="candidatePlacement.startDate" v-show="false" v-validate="'required'"
                 name="availableDate"/>
          <span v-if="errors.first('availableDate')" class="small text-danger">Dit veld is verplicht</span>
        </div>
        <div class="form-group col-lg-2">
          <label for="candidatePlacement-hourlyWage">Uurloon</label>
          <input
            v-validate="'required'"
            name="customer-hourlyWage"
            id="candidatePlacement-hourlyWage"
            type="number"
            class="form-control"
            v-model="candidatePlacement.hourlyWage"
          />
          <span v-if="errors.first('customer-hourlyWage')" class="small text-danger">Dit veld mag alleen cijfers en komma's bevatten.</span>
        </div>
        <div class="col-lg-3">
          <label>Pensioen</label>
            <v-select :options="getStandardFormChoices('retirements')"
                      v-model="candidatePlacement.retirement"
                      label="name"
                      :selectOnTab="true"
            />
        </div>
      </div>
      <div class="col-xl-12 mb-3" style="padding-top: 0px; text-align: right;">
        <input type="checkbox" id="flexworker-hourapp" v-model="createHourAppAccount" />
        <label for="flexworker-hourapp" style="margin-left: 5px">Create account in Hour APP</label>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="customer-defaultInstructions">Welkomst e-mail</label>
          <tiptap-editor
            v-model="candidatePlacement.firstDayInstructions"
            :content="candidatePlacement.firstDayInstructions"/>
        </div>
      </div>
    </template>
    <div slot="portletFooter" class="col-12 text-right">
      <button @click="saveCandidatePlacement" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>


<script>
  import {mapGetters} from "vuex";
  import Datepicker from "vuejs-datepicker";
  import {nl} from "vuejs-datepicker/dist/locale";
  import Vue from 'vue';
  import store from "@/store";
  import { buildFlexworkerHourAppPayload, describeHourAppSyncOutcome } from "@/utils/placementSync";

  export default {
    props: ["id", "customer", "vacancy"],
    components: {
      Datepicker
    },
    data() {
      return {
        nl: nl,
        renderedComponent: true,
        candidatePlacementCopy: null,
        createHourAppAccount: false,
        candidatePlacement: {
          customerId: '',
          vacancyId: null,
          candidate: null,
          startDate: null,
          hourlyWage: null,
          firstDayInstructions: null,
          retirement: null
        }
      };
    },
    methods: {
      getCandidateLabel(option) {
        return `${option.firstName} ${option.lastName}`;
      },
      removeCandidateFromPool(customerId, candidateId) {
        const poolsOfCandidate = this.getPoolsOfCandidateId(candidateId);
        _.filter(poolsOfCandidate, {
          'customerId': customerId,
          'archived': false
        }).forEach(pool => {
          this.$store.dispatch('pools/patch', {
            id: pool.id,
            archived_at: new Date(),
            archived_by: this.$store.getters.getUserData,
            archived: true
          })
        });
      },
      renderComponent() {
        this.renderedComponent = false;

        this.$nextTick(() => {
          this.renderedComponent = true;
        });
      },

      saveCandidatePlacement() {
        if(this.candidatePlacement.startDate) {
          this.candidatePlacement.startDate = moment(this.candidatePlacement.startDate).format("YYYY-MM-DD")
        }
        if(this.candidatePlacement.vacancyId === null) {
          delete this.candidatePlacement.vacancyId
        }
        delete this.candidatePlacement.candidate
        
        this.$validator.validate().then(result => {
          if (result) {
            this.candidatePlacement.candidateIsHolidayWorker = _.includes(_.find(this.getCandidates, {'id': this.candidatePlacement.candidateId }).shifts, "Vakantiekracht");
            const userData = this.$store.getters.getUserData;
            this.candidatePlacement.createdBy = userData;
            this.candidatePlacement.department = userData.selectedDepartment;
            this.candidatePlacementCopy = this.candidatePlacement;
            this.$store.dispatch("placements/set", this.candidatePlacement).then(() => {
              this.removeCandidateFromPool(this.candidatePlacement.customerId, this.candidatePlacement.candidateId)
              this.$toasted.global.successRequest({
                message: "Plaatsing aangemaakt"
              });

              let candidate = this.getCandidate(this.candidatePlacement.candidateId)
              if(this.createHourAppAccount) {
                const payload = buildFlexworkerHourAppPayload({
                    candidatePlacement: this.candidatePlacement,
                    candidate,
                    customer: this.getCustomer(this.candidatePlacement.customerId),
                });
                this.$store.dispatch('users/postUserHourApp', {ApiClient: Vue.prototype.$ApiClient, user: payload}).then((res) => {
                  const outcome = describeHourAppSyncOutcome(res);

                  if (!outcome.ok) {
                    this.$toasted.global.failedRequest({message: outcome.message});
                  }
                })
              }
            }).catch(error => {
              this.$toasted.global.failedRequest();
              console.log(error)
            });

            this.renderComponent();
            this.$emit("unsavedChanges", false);
            this.$emit('setCustomerPage', 'customerPlacingHistory');
          } else {
            this.$toasted.global.failedFormRequest();
          }
        });
      },
      getCandidate(id) {
        return this.getCandidates.find(candidate => candidate.id === id);
      }
    },
    computed: {
      ...mapGetters("vacancies", [
        "getVacancies",
        "getVacanciesFromCustomer"
      ]),
      ...mapGetters("candidates", ["getCandidates", "getAvailableCandidatesPerCustomer", "getStandardFormChoices"]),
      ...mapGetters('pools', ['getPoolsOfCandidateId']),
      ...mapGetters("customers", ["getCustomer", "getCustomers", "getAvailableCustomersPerCandidate"]),
      ...mapGetters("users", ["getUserData"]),
    },
    watch: {
      candidatePlacement: {
        handler: function (val) {
          this.$emit("unsavedChanges", JSON.stringify(val) !== JSON.stringify(this.candidatePlacementCopy));
        },
        deep: true
      }
    },
    created() {
      this.candidatePlacement.customerId = this.customer.id;
      this.customerName = this.customer.name;
      this.candidatePlacement.firstDayInstructions = this.customer.defaultInstructions
      this.candidatePlacementCopy = JSON.parse(
        JSON.stringify(this.candidatePlacement)
      );
    }
  };
</script>